import React from 'react';
import * as ROUTES from '../../../router/Routes';
import ContainerTemplate from '../../../widgets/template/Container';
import ResultadosView from './ResultadosView';

const ResultadosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.resultados}
      routes={[ROUTES.juegosDeportivos]}
    >
      <ResultadosView />
    </ContainerTemplate>
  );
};

export default ResultadosModule;
